import { useState } from "react";
import {ContactMeContainer, Close, CloseIcon, ContactMeContent, ContactMeHeadline, ContactMeSubtitle, ModalInputContainer, ModalInput, ErrorMessage, Button, HighlightedBox, HighlightedBoxContainer, HighlightedBoxLabel, HighlightedBoxNumb, HighlightedBoxLeft, HightlightedBoxRight, HighlightedBoxHeadline, Hr, ValueDef, ConsentCheckbox, ConsentLabel, ConsentRow } from "./Leadpopup.style";
import { postSalaryInsuranceLeadData } from "../../../../utils/api";
import { SalaryInsuranceLeadModel } from "../../../../types/SalaryInsuranceLeadModel";
import { getCookie } from "../../../../utils/cookieService";
import Analytics from "../../../../utils/analytics";

interface Props {
      onClose: () => void;
      onSuccess?: () => void;
      salary: string;
      period: string;
      amount: string;
      fullAmount: string;
      price: string;
      leverandoer: string;
}

export default function Leadpopup({onClose, onSuccess, salary, period, amount, fullAmount, price, leverandoer }:Props) {
    const [firstName, setFirstName] = useState<string>("");
    const [mobile, setMobile] = useState<string>("");
    //const [email, setEmail] = useState<string>("");
    //const [consentChecked, setConsentChecked] = useState<boolean>(false);
    const [showMobileError, setShowMobileError] = useState<boolean>(false);
    const [showFirstNameError, setShowFirstNameError] = useState<boolean>(false);
    //const [showConsentError, setShowConsentError] = useState<boolean>(false);
    //const [showEmailError, setShowEmailError] = useState<boolean>(false);

    const getNameIsValid = (value: string) => value.trim().length >= 2;

    const getMobileIsValid = (value: string) => {
        const normalizedMobile = value.replace(/\s|-/g, "");
        return /^(?:\+45)?\d{8}$/.test(normalizedMobile);
    };

    //removed email validation and consent box 
  /*   const getEmailIsValid = (value: string) => {
        const normalizedEmail = value.trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
    }; */

    //Api send contact me
    const onSend = async () => {
        const cookie = getCookie("__exponea_etc__");

        let lead = {} as SalaryInsuranceLeadModel;
        lead.name = firstName.trim()
        lead.phone = mobile.trim()
        lead.grosspay = `${salary}`
        lead.dinpris  = `${price}`
        lead.payout = `${fullAmount}`
        lead.payoutduration = `${period}`
        lead.product = `Lønsikring`
        lead.cookie = `${cookie}`
        lead.email = ""
        lead.leverandoer = `${leverandoer}` || "www.ase.dk"

        try {
            await postSalaryInsuranceLeadData({ ...lead });
            // Call callbacks after successful submission
            console.log("Lead submitted successfully:", lead);
            onSuccess?.();
            Analytics.getInstance().trackSalaryInsuranceAction("form_completed", salary, amount, period, price, fullAmount);
            // Close popup after a brief delay to ensure state updates
            setTimeout(() => {
                onClose();
            }, 100);
        } catch (error) {
            console.error("Error submitting lead:", error);
            // Still close popup and show confirmation even if there's an error
            onSuccess?.();
            setTimeout(() => {
                onClose();
            }, 100);
        }
    } 

    const onClosePopup = () => {
        onClose()
        Analytics.getInstance().trackSalaryInsuranceAction("form_closed", salary, amount, period, price, fullAmount)
    }

    //Validation for contact me inputs
    const checkSubmit = () => {
        const isNameValid = getNameIsValid(firstName);
        const isMobileValid = getMobileIsValid(mobile);
        //const isEmailValid = getEmailIsValid(email);
        //const isConsentValid = consentChecked;

        setShowFirstNameError(!isNameValid);
        setShowMobileError(!isMobileValid);
        //setShowEmailError(!isEmailValid);
        //setShowConsentError(!isConsentValid);

        if (isNameValid && isMobileValid) {
            onSend()
            setFirstName("")
            setMobile("")
            //setEmail("")
            //setConsentChecked(false)
            setShowMobileError(false)
            setShowFirstNameError(false)
            //setShowEmailError(false)
            //setShowConsentError(false)
        }
    }

    const isFormValid = getNameIsValid(firstName) && getMobileIsValid(mobile);

    return (
        <ContactMeContainer data-attribute="contact-me">
            <ContactMeContent>
                <Close>
                    <CloseIcon onClick={onClosePopup}/>
                </Close>
                <ContactMeHeadline>Næste skridt: Få din lønsikring på plads</ContactMeHeadline>
                <ContactMeSubtitle>Vi ringer dig op og hjælper dig med at oprette din lønsikring korrekt.</ContactMeSubtitle>
                <HighlightedBox>
                    <HighlightedBoxHeadline>Dine valg</HighlightedBoxHeadline>
                    <HighlightedBoxContainer>
                        <HighlightedBoxLeft>
                            <HighlightedBoxLabel>Dækningsperiode</HighlightedBoxLabel>
                        </HighlightedBoxLeft>
                        <HightlightedBoxRight>
                            <HighlightedBoxNumb>{period} <ValueDef>mdr.</ValueDef></HighlightedBoxNumb>
                        </HightlightedBoxRight>
                    </HighlightedBoxContainer>
                    <Hr />
                    <HighlightedBoxContainer>
                        <HighlightedBoxLeft>
                            <HighlightedBoxLabel>Bruttoløn</HighlightedBoxLabel>
                            <HighlightedBoxLabel>Dækningssum</HighlightedBoxLabel>
                        </HighlightedBoxLeft>
                        <HightlightedBoxRight>
                            <HighlightedBoxNumb>{salary} <ValueDef>kr./md</ValueDef></HighlightedBoxNumb>
                            <HighlightedBoxNumb>{amount} <ValueDef>kr./md</ValueDef></HighlightedBoxNumb>
                        </HightlightedBoxRight>
                    </HighlightedBoxContainer>
                    <Hr />
                    <HighlightedBoxContainer>
                        <HighlightedBoxLeft>
                            <HighlightedBoxLabel>Samlede udbetaling</HighlightedBoxLabel>
                            <HighlightedBoxLabel>Din pris</HighlightedBoxLabel>
                        </HighlightedBoxLeft>
                        <HightlightedBoxRight>
                            <HighlightedBoxNumb>{fullAmount} <ValueDef>kr./md</ValueDef></HighlightedBoxNumb>
                            <HighlightedBoxNumb>{price} <ValueDef> kr./md</ValueDef></HighlightedBoxNumb>
                        </HightlightedBoxRight>
                    </HighlightedBoxContainer>
                </HighlightedBox>
                <ModalInputContainer>
                    <ModalInput id="name" type="text" placeholder="Dit navn" autoComplete="given-name"  
                        value={firstName}
                        onChange={(e) => {
                            setFirstName(e.currentTarget.value);
                            if (showFirstNameError) {
                                setShowFirstNameError(!getNameIsValid(e.currentTarget.value));
                            }
                        }}
                    />
                    {showFirstNameError &&
                        <ErrorMessage>Hov, indtast dit navn (mindst 2 tegn)</ErrorMessage>
                    }
                    <ModalInput id="tel" type="tel" placeholder="Dit telefonnummer" autoComplete="tel"
                        value={mobile}
                        onChange={(e) => {
                            setMobile(e.currentTarget.value);
                            if (showMobileError) {
                                setShowMobileError(!getMobileIsValid(e.currentTarget.value));
                            }
                        }}
                    />
                    {showMobileError && 
                        <ErrorMessage>Hov, indtast et gyldigt telefonnummer (8 cifre)</ErrorMessage>
                    }
                   {/*  <ModalInput
                        id="email"
                        type="email"
                        placeholder="Din email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.currentTarget.value);
                            if (showEmailError) {
                                setShowEmailError(!getEmailIsValid(e.currentTarget.value));
                            }
                        }}
                    /> */}
                    {/* {showEmailError && <ErrorMessage>Hov, indtast en gyldig email</ErrorMessage>}
                    <ConsentRow>
                        <ConsentCheckbox
                            id="lead-consent"
                            type="checkbox"
                            checked={consentChecked}
                            onChange={(e) => {
                                const isChecked = e.currentTarget.checked;
                                setConsentChecked(isChecked);
                                if (showConsentError) {
                                    setShowConsentError(!isChecked);
                                }
                            }}
                        />
                        <ConsentLabel htmlFor="lead-consent">
                            Ja tak – jeg vil gerne modtage eksklusive rabatter og medlemstilbud fra Ases <a target="_blank" href="https://www.ase.dk/gdpr/ase-a-kasse-samarbejdspartnere" style={{ textDecoration: "underline" }}>fordelspartnere</a> samt udvalgte medlemsfordele fra Ase, som kan spare mig penge i hverdagen. <br/>Det er altid Ase, der kontakter mig.<br/>Jeg må kontaktes via e‑mail, sms og telefon. Mit samtykke kan altid trækkes tilbage.
                        </ConsentLabel>
                    </ConsentRow>
                    {showConsentError &&
                        <ErrorMessage>Hov, du skal give samtykke for at fortsætte</ErrorMessage>
                    } */}
                </ModalInputContainer>
                <Button
                    className="button"
                    as="button"
                    type="button"
                    onClick={checkSubmit}
                    active={isFormValid}
                    disabled={!isFormValid}
                >
                    Ring mig op
                </Button>
            </ContactMeContent>
        </ContactMeContainer>
    )
}